import HelpLink from '../HelpLink';
import { connect } from 'react-redux';
import { useGlobalContext } from 'context/GlobalContext';
import { PhoneLink } from '../PhoneLink';

const AuctionRules = ({ isCharity = false }) => {
    const { user: userData } = useGlobalContext();

    const showPhone = !(userData?.membership?.type === 'Basic Bidder' || !userData?.user_id);

    const renderAuctionRulesCharity = () => (
        <>
            <p>
                <strong>NOTICE TO BIDDERS:</strong>
                {' '}
                When placing a bid, the buyer accepts the fact that he or she is entering into a legally binding contract. The following auction rules apply. (Highlights from
                {' '}
                <a target="_blank" href="/terms">Terms of Use</a>
                )
            </p>
            <ul>
                <li>100% of the Sale Price and Buyer Premium will be charged to the credit card on file.</li>
                <li>$10 Bid Increments.</li>
                <li>Bids placed within the last 3 minutes will extend the auction so 3 minutes are added to the remaining time (refresh your screen often to see the most updated bid amount).</li>
                <li>Upon auction winning, the StorageTreasures Services Buyer’s Premiums are as follows:
                    <ul>
                        <li>Basic Bidder ($0.00/mo) – 18%.</li>
                        <li>ProBidder ($10.00/mo) – 15%.</li>
                        <li>ProBidder Max ($20.00/mo) – 12%.</li>
                        <li>ProBusiness ($30.00/mo) – 9%.</li>
                    </ul>
                </li>
{/*                <li>The high bid amount is limited per membership, based on successful closed auction experience.  A bidder may not bid over $1,000 until the following number is successfully bid, won, and cleaned out within facility policy:
                    <ul>
                        <li>Basic Bidder ($0.00/mo) – 5 wins before $1,000+ bids can be made.</li>
                        <li>ProBidder ($10.00/mo) – 3 wins before $1,000+ bids can be made.</li>
                        <li>ProBidder Max ($20.00/mo) – No limitation on $1,000+ bids.</li>
                        <li>ProBusiness ($30.00/mo) – No limitation on $1,000+ bids.</li>
                    </ul>
                </li>*/}
                <li>The number of auctions a bidder can be the highest bidder at any time is limited by membership. Auction leader/highest bidder restrictions enforced are as follows:
                    <ul>
                        <li>Basic Bidder ($0.00/mo) – 3 auctions at one time. Restriction removed after 5 won auctions.</li>
                        <li>ProBidder ($10.00/mo) – 5 auctions at one time. Restriction removed after 3 won auctions.</li>
                        <li>ProBidder Max ($20.00/mo) – Unlimited number of auctions at one time.</li>
                        <li>ProBusiness ($30.00/mo) – Unlimited number of auctions at one time.</li>
                    </ul>
                </li>
                <li>The distance a bidder may bid from their zip code is limited by membership. Auction distance bidding is enforced as follows:
                    <ul>
                        <li>Basic Bidder ($0.00/mo) – 300 Miles from zip code.</li>
                        <li>ProBidder ($10.00/mo) – 500 Miles from zip code.</li>
                        <li>ProBidder Max ($20.00/mo) – 1,000 Miles from zip code.</li>
                        <li>ProBusiness ($30.00/mo) – No limit to the distance from zip code.</li>
                    </ul>
                </li>
                <li>In case the amount for the buyer premium, considering the premium percentage is lower than $10, a minimum premium of $10 will be applied.</li>
                <li>In addition to the buyer premium, a 10% deposit of the sale price may be charged to the card on file.</li>
                <li>The defaulted tenant has the legal right to cure the account thus canceling the auction up until the cash payment is received from the winning bidder unless otherwise stated in the state's lien laws or by the storage facility.</li>
                <li>The cleaning deposit may vary by storage facility. Please check the information for each auction.</li>
                <li>The storage facility is responsible for collecting the cleaning deposit.</li>
                <li>Clean-out time may vary by storage facility. Please check the information for each auction.</li>
                <li>Sales tax may be collected at the facility unless verification of exemption is provided.</li>
                <li>All auction unit(s) are subject to cancellation by the storage facility.</li>
                <li>If the winning bidder has not submitted payment within 24 hours of the auction close time, the unit can be offered to alternate bidders.</li>
                <li>The unit can be offered to alternate bidders in case specific conditions arise.</li>
                <li>Bidders are liable for their winning bids and associated premiums, taxes, and fees regardless of whether they claim the property in the auction unit(s).</li>
                <li>By registering and bidding on StorageTreasures.com, an auction buyer agrees not to dispute any credit card charges processed through this site.</li>
                <li>Units that are not paid for nor vacated within the allotted cleanout time will result in account suspension.</li>
                <li>Violation of any terms may prevent you from using the StorageTreasures services.</li>
            </ul>
            <p>
                <PhoneLink>
                    {({phoneNumber}) => (
                        <>If you have any questions at all, please check out our Help Center, use our Live Chat feature, or give us a call at <span>{phoneNumber}</span>. </>
                    )}
                </PhoneLink>
                {!showPhone && <>If you have any questions at all, please check out our Help Center or use our Live Chat feature.{' '}</>}
                Our <HelpLink showSupportEmail url="/articles/360007933353-Buyer-FAQs">Buyer FAQs</HelpLink>{' '} page is particularly helpful.
            </p>
            <p>StorageTreasures.com is proud to be the internet’s leading online storage auction marketplace and provider of storage auctions near you.</p>
        </>
    );

    const renderAuctionRules = () => (
        <>
            <p>
                <strong>NOTICE TO BIDDERS:</strong>
                {' '}
                When placing a bid, the buyer accepts the fact that he or she is entering into a legally binding contract. The following auction rules apply. (Highlights from
                {' '}
                <a target="_blank" href="/terms">Terms of Use</a>
                )
            </p>
            <ul>
                <li>$10 Bid Increments.</li>
                <li>Bids placed within the last 3 minutes will extend the auction so 3 minutes are added to the remaining time (refresh your screen often to see the most updated bid amount).</li>
                <li>Upon auction winning, the StorageTreasures Services Buyer’s Premiums are as follows:
                    <ul>
                        <li>Basic Bidder ($0.00/mo) – 18%.</li>
                        <li>ProBidder ($10.00/mo) – 15%.</li>
                        <li>ProBidder Max ($20.00/mo) – 12%.</li>
                        <li>ProBusiness ($30.00/mo) – 9%.</li>
                    </ul>
                </li>
{/*                <li>The high bid amount is limited per membership, based on successful closed auction experience.  A bidder may not bid over $1,000 until the following number is successfully bid, won, and cleaned out within facility policy:
                    <ul>
                        <li>Basic Bidder ($0.00/mo) – 5 wins before $1,000+ bids can be made.</li>
                        <li>ProBidder ($10.00/mo) – 3 wins before $1,000+ bids can be made.</li>
                        <li>ProBidder Max ($20.00/mo) – No limitation on $1,000+ bids.</li>
                        <li>ProBusiness ($30.00/mo) – No limitation on $1,000+ bids.</li>
                    </ul>
                </li>*/}
                <li>The number of auctions a bidder can be the highest bidder at any time is limited by membership. Auction leader/highest bidder restrictions enforced are as follows:
                    <ul>
                        <li>Basic Bidder ($0.00/mo) – 3 auctions at one time. Restriction removed after 5 won auctions.</li>
                        <li>ProBidder ($10.00/mo) – 5 auctions at one time. Restriction removed after 3 won auctions.</li>
                        <li>ProBidder Max ($20.00/mo) – Unlimited number of auctions at one time.</li>
                        <li>ProBusiness ($30.00/mo) – Unlimited number of auctions at one time.</li>
                    </ul>
                </li>
                <li>The distance a bidder may bid from their zip code is limited by membership. Auction distance bidding is enforced as follows:
                    <ul>
                        <li>Basic Bidder ($0.00/mo) – 300 Miles from zip code.</li>
                        <li>ProBidder ($10.00/mo) – 500 Miles from zip code.</li>
                        <li>ProBidder Max ($20.00/mo) – 1,000 Miles from zip code.</li>
                        <li>ProBusiness ($30.00/mo) – No limit to the distance from zip code.</li>
                    </ul>
                </li>
                <li>In case the amount for the buyer premium, considering the premium percentage is lower than $10, a minimum premium of $10 will be applied.</li>
                <li>In addition to the buyer premium, a 10% deposit of the sale price may be charged to the card on file.</li>
                <li>The defaulted tenant has the legal right to cure the account thus canceling the auction up until the cash payment is received from the winning bidder unless otherwise stated in the state's lien laws or by the storage facility.</li>
                <li>The cleaning deposit may vary by storage facility. Please check the information for each auction.</li>
                <li>The storage facility is responsible for collecting the cleaning deposit.</li>
                <li>Clean-out time may vary by storage facility. Please check the information for each auction.</li>
                <li>Sales tax may be collected at the facility unless verification of exemption is provided.</li>
                <li>All auction unit(s) are subject to cancellation by the storage facility.</li>
                <li>If the winning bidder has not submitted payment within 24 hours of the auction close time, the unit can be offered to alternate bidders.</li>
                <li>The unit can be offered to alternate bidders in case specific conditions arise.</li>
                <li>Bidders are liable for their winning bids and associated premiums, taxes, and fees regardless of whether they claim the property in the auction unit(s).</li>
                <li>By registering and bidding on StorageTreasures.com, an auction buyer agrees not to dispute any credit card charges processed through this site.</li>
                <li>Units that are not paid for nor vacated within the allotted cleanout time will result in account suspension.</li>
                <li>Violation of any terms may prevent you from using the StorageTreasures services.</li>
            </ul>
            <p>
                <PhoneLink>
                    {({phoneNumber}) => (
                        <>If you have any questions at all, please check out our Help Center, use our Live Chat feature, or give us a call at <span>{phoneNumber}</span>. </>
                    )}
                </PhoneLink>
                {!showPhone && <>If you have any questions at all, please check out our Help Center or use our Live Chat feature.{' '}</>}
                Our <HelpLink showSupportEmail url="/articles/360007933353-Buyer-FAQs">Buyer FAQs</HelpLink>{' '} page is particularly helpful.
            </p>
            <p>StorageTreasures.com is proud to be the internet’s leading online storage auction marketplace and provider of storage auctions near you.</p>
        </>
    );

    return isCharity ? renderAuctionRulesCharity() : renderAuctionRules();
};

export default connect(({ user }) => ({ user }))(AuctionRules);
